import React from 'react';

export const ModuleContext = React.createContext('');
